export const ImageIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
  >
    <path
      d="M2.0625 18C1.49531 18 1.0096 17.804 0.605345 17.412C0.201095 17.02 -0.000685749 16.5493 1.75085e-06 16V2C1.75085e-06 1.45 0.202127 0.979002 0.606377 0.587002C1.01063 0.195002 1.496 -0.000664969 2.0625 1.69779e-06H16.5C17.0672 1.69779e-06 17.5529 0.196002 17.9572 0.588002C18.3614 0.980002 18.5632 1.45067 18.5625 2V16C18.5625 16.55 18.3604 17.021 17.9561 17.413C17.5519 17.805 17.0665 18.0007 16.5 18H2.0625ZM3.09375 14H15.4688L11.6016 9L8.50781 13L6.1875 10L3.09375 14Z"
      fill="#48D23C"
    />
  </svg>
);
